export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    login: string;
    email: string;
    accessToken: string;
    visualizarAprovacaoComercial: boolean;
    visualizarProtocoloTerceiros: boolean;
    movimentarProtocoloTerceiros: boolean;
    movimentarProtocoloAccenture : boolean;
    criarPedidos: boolean;
}
